import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
export default {
  props: {
    ticketNotes: {
      type: Array,
      default: []
    },
    performanceId: {
      type: Number,
      default: 0
    },
    isCategory: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      list: [],
      showPop: false
    };
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      cid: 'c_c21utqjf',
      bid: 'b_movie_43e7p8c3_mv',
      custom: {
        performance_id: this.performanceId
      }
    });
    this.list = this.ticketNotes.map(function (item) {
      item.contentList = item.content.split('\n');
      return item;
    });
  },
  methods: {
    triggerPop: function triggerPop() {
      this.showPop = !this.showPop;
      if (this.showPop) {
        var cssStr = 'overflow-y: hidden; height: 100%;';
        document.getElementsByTagName('body')[0].style.cssText = cssStr;
        document.body.style.cssText = cssStr;
        window.lxTagReport('c_c21utqjf', 'b_movie_43e7p8c3_mc', {
          performance_id: this.performanceId
        });
        window.seedAction({
          evt: 'click',
          bid: 'b_movie_43e7p8c3_mc',
          cid: 'c_c21utqjf',
          custom: {
            performance_id: this.performanceId
          }
        });
      } else {
        var _cssStr = 'overflow-y: auto; height: auto;';
        document.getElementsByTagName('body')[0].style.cssText = _cssStr;
        document.body.style.cssText = _cssStr;
      }
    },
    onClose: function onClose() {
      this.showPop = false;
      var cssStr = 'overflow-y: auto; height: auto;';
      document.getElementsByTagName('body')[0].style.cssText = cssStr;
      document.body.style.cssText = cssStr;
    }
  }
};